import React from 'react';
import '../styles/groups-hero-section.css';

const GroupsHeroSection = ({ user, userGroups, userStats }) => {
  // Calculate stats from user's groups
  const calculateStats = () => {
    if (!userGroups || userGroups.length === 0) {
      return {
        totalGroups: 0,
        leadingCount: 0,
        bestPerformance: null,
        bestGroupName: null
      };
    }

    let leadingCount = 0;
    let bestPerformance = null;
    let bestGroupName = null;

    userGroups.forEach(group => {
      if (group.userRanking?.rank === 1) {
        leadingCount++;
      }
      if (group.userRanking?.profitLossPercent !== undefined) {
        if (bestPerformance === null || group.userRanking.profitLossPercent > bestPerformance) {
          bestPerformance = group.userRanking.profitLossPercent;
          bestGroupName = group.name;
        }
      }
    });

    return {
      totalGroups: userGroups.length,
      leadingCount,
      bestPerformance,
      bestGroupName
    };
  };

  const stats = userStats || calculateStats();
  const firstName = user?.firstName || user?.name?.split(' ')[0] || 'Investor';

  // Format percentage
  const formatPercentage = (percent) => {
    if (percent === null || percent === undefined) return null;
    return `${percent >= 0 ? '+' : ''}${percent.toFixed(1)}%`;
  };

  return (
    <div className="groups-hero-section">
      <div className="hero-greeting">
        <h1>Hey {firstName}! 👋</h1>
      </div>

      <div className="hero-stats-row">
        {stats.leadingCount > 0 && (
          <div className="hero-stat highlight">
            <span className="stat-icon">🏆</span>
            <span className="stat-text">
              You're <strong>#1</strong> in {stats.leadingCount} group{stats.leadingCount !== 1 ? 's' : ''}!
            </span>
          </div>
        )}

        {stats.bestPerformance !== null && stats.bestGroupName && (
          <div className="hero-stat">
            <span className="stat-icon">📈</span>
            <span className="stat-text">
              Best: <strong className={stats.bestPerformance >= 0 ? 'positive' : 'negative'}>
                {formatPercentage(stats.bestPerformance)}
              </strong> in "{stats.bestGroupName}"
            </span>
          </div>
        )}

        {stats.totalGroups > 0 && stats.leadingCount === 0 && (
          <div className="hero-stat motivational">
            <span className="stat-icon">💪</span>
            <span className="stat-text">
              Keep investing to climb the leaderboards!
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default GroupsHeroSection;
